export default function ($scope) {

};


/** WEBPACK FOOTER **
 ** ./js/theme/purchases/error/controller.js
 **/